import {commonService} from "./common.services";

export  const galleryService = {
    getAllGallery,
    saveGallery,
    downloadFile
}

function getAllGallery(data) {

    return commonService.sendHttpRequest('rbuilder/loadgallery', data, "POST");
}

function saveGallery(data) {

    return commonService.sendHttpRequest('rbuilder/savegallery', data, "POST");
}

function downloadFile(data) {

    return commonService.sendHttpRequest('rbuilder/downloadfile', data, "POST");
}


// WEBPACK FOOTER //
// ./src/services/gallery.services.js